// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__QLkGT","title":"style_title__UkfQa","closeIcon":"style_closeIcon__iP2J2"};